import { watch } from 'vue'
import { currentUser, persistentSettings } from '../shared/local-storage'
import { module } from './module-state'

watch(module, () => {
  persistentSettings.value.lastModule = module.value
})

const getLastModule = () => persistentSettings.value.lastModule

const currentUserHasModule = module => currentUser.value?.modules?.includes(module)

export const setDefaultModule = () => {
  const lastModule = getLastModule()
  module.value = currentUserHasModule(lastModule) ? lastModule : currentUser.value?.modules?.[0]
}
